/**
 * Options for downloading a blob as a file
 */
interface DownloadBlobOptions {
    /** The blob data to download */
    blob: Blob;
    /** The filename to save the downloaded file as */
    filename: string;
}

/**
 * Downloads a blob as a file by creating a temporary download link and triggering it.
 *
 * This function creates an object URL from the provided blob, creates a temporary anchor element,
 * sets it to download the blob with the specified filename, programmatically clicks it to trigger
 * the download, and then cleans up by revoking the object URL.
 *
 * @param options - The download options containing the blob and filename
 * @param options.blob - The blob data to be downloaded
 * @param options.filename - The name to give the downloaded file
 *
 * @example
 * ```typescript
 * const blob = new Blob(['Hello, World!'], { type: 'text/plain' });
 * downloadBlob({ blob, filename: 'hello.txt' });
 * ```
 */
export const downloadBlob = (options: DownloadBlobOptions) => {
    const url = URL.createObjectURL(options.blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = options.filename;
    a.click();
    URL.revokeObjectURL(url);
};
